import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import HeaderDirectoryWithholding from './HeaderDirectoryWithholding';
import RowDirectoryWithholding from './RowDirectoryWithholding';
import { StyledTableWrapper } from './style';

const SelectEmployerWithholding = ({ data, setEmployeeSelected, resetRow }) => {
  const [rowSelected, setRowSelected] = useState(0);
  useEffect(() => {
    if (resetRow) {
      setRowSelected(0);
    }
  });
  return (
    <StyledTableWrapper>
      <HeaderDirectoryWithholding />
      {data.map((item, i) => (
        <RowDirectoryWithholding
          key={`row-d-${i + 1}`}
          row={i + 1}
          dataRow={item}
          rowSelected={rowSelected}
          setRowSelected={setRowSelected}
          setEmployeeSelected={setEmployeeSelected}
        />
      ))}
    </StyledTableWrapper>
  );
};
SelectEmployerWithholding.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      lastname: PropTypes.string,
      profile: PropTypes.string,
      department: PropTypes.string,
      extension: PropTypes.number,
      phones: PropTypes.string,
      email: PropTypes.string
    })
  )
};

export default SelectEmployerWithholding;
